import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=c8b169a8&scoped=true&"
import script from "./CustomSearch.vue?vue&type=script&lang=ts&"
export * from "./CustomSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b169a8",
  null
  
)

export default component.exports